module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div id=\"lottie-<%=block.ID%>\" class=\"lottie-target mb-5\">\n\t<%if (block.Blurb_id){\n\t\ttext[block.Blurb_id].forEach(function(blurb){%>\n\t\t\t<div class=\"blurb\" <%if(blurb.Seconds){%>seconds='<%=blurb.Seconds%>'<%}%>><%- parseMarkdown(blurb.Text) %></div>\n\n\t\t<%})\n\t}%>\n</div>\n\n\n"
  , __filename = "/Users/maryanne/dev/graphics_2021-taiwan-story-2/src/js/article.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"lottie-")
    ; __append(escapeFn(block.ID))
    ; __append("\" class=\"lottie-target mb-5\">\n	")
    ; __line = 2
    ; if (block.Blurb_id){
		text[block.Blurb_id].forEach(function(blurb){
    ; __line = 3
    ; __append("\n			<div class=\"blurb\" ")
    ; __line = 4
    ; if(blurb.Seconds){
    ; __append("seconds='")
    ; __append(escapeFn(blurb.Seconds))
    ; __append("'")
    ; }
    ; __append(">")
    ; __append( parseMarkdown(blurb.Text) )
    ; __append("</div>\n\n		")
    ; __line = 6
    ; })
	}
    ; __line = 7
    ; __append("\n</div>\n\n\n")
    ; __line = 11
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=/Users/maryanne/dev/graphics_2021-taiwan-story-2/src/js/article.ejs

}